import React from "react";

function FolderOpen() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="folder-open" className="svg-inline--fa fa-folder-open fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M69.08 271.63L0 390.05V112a48 48 0 0 1 48-48h160l64 64h160a48 48 0 0 1 48 48v48H152a96.31 96.31 0 0 0-82.92 47.63z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M152 256h400a24 24 0 0 1 20.73 36.09l-72.46 124.16A64 64 0 0 1 445 448H45a24 24 0 0 1-20.73-36.09l72.45-124.16A64 64 0 0 1 152 256z"></path></g></svg>
    );
  }

export default FolderOpen;